import styled from "styled-components";

export const ContainerBase = styled.div`
  background-color: white;
  margin-top: 10px;
`;

export const Column = styled.div`
  //padding-left: 25px;
`;

export const Paragraph = styled.p`
  font-size: 0.8em;
  font-weight: 700;
  color: #9E9E9E;
  display: flex;
  span {
    font-weight: 500;
  }
`;

export const ParagraphMsg = styled.p`
  font-size: 1.2em;
  font-weight: 700;
  color: gray;
  padding-left: 20px;
`;

export const Label = styled.label`
  color: gray;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  margin: 0;
  display: flex;
  margin: 5px 0;
  :hover {
    cursor: pointer;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const FiltersContainer = styled.div`
  margin-top: 10px;
  /* align-items: center; */
  padding-bottom: 20px;
  padding-right: 20px;
  padding-left: 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  /* justify-content: center; */
`;
